export const keysToSnake = function (o, keysToSkip) {
    if (isObject(o)) {
        const n = {};
        Object.keys(o)
            .forEach((k) => {
            if (!keysToSkip || !keysToSkip.includes(k)) {
                n[toSnake(k)] = keysToSnake(o[k], keysToSkip);
            }
            else {
                n[toSnake(k)] = o[k];
            }
        });
        return n;
    }
    else if (isArray(o)) {
        return o.map((i) => {
            return keysToSnake(i, keysToSkip);
        });
    }
    return o;
};
export const toSnake = (s) => {
    return s.replace(/\.?([A-Z]+)/g, (x, y) => {
        return '_' + y.toLowerCase();
    }).replace(/^_/, '').replace(' ', '');
};
export const isArray = function (a) {
    return Array.isArray(a);
};
export const isObject = function (o) {
    return o === Object(o) && !isArray(o) && typeof o !== 'function';
};
